<template>
<!-- 集团管理 -->
  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">

        <el-col :span="8" style="margin-bottom: 10px;">
          <span class="title">集团名称:</span>

          <el-input v-model="search_data.group_name" style="width: 200px;"></el-input>


        </el-col>

        <el-col :span="8" style="margin-bottom: 10px;">
          <span class="title">成员手机号:</span>

          <el-input v-model="search_data.phone" maxlength="11" style="width: 200px;"></el-input>


        </el-col>

        <el-col :span="8" style="margin-bottom: 10px;">
          <span class="title">充值优惠状态:</span>


          <el-select
                  v-model="search_data.activity_status"
                  placeholder="充值优惠状态"
                  clearable
                  @keyup.enter.native="searchgroupWalletLists"

          >
            <el-option label="关闭" value="0"> </el-option>
            <el-option label="按固定金额" value="1"> </el-option>
            <el-option label="按百分比" value="2"> </el-option>
            </el-select>
        </el-col>


      </el-row>



      <el-button type="primary" icon="el-icon-search" @click="searchgroupWalletLists">搜索</el-button>
      <el-button @click="addGroup_show = !addGroup_show">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
      <el-button @click="water_isShow = !water_isShow"
              >集团账户流水</el-button
            >

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->

            <el-form-item label="提现:">
              <span>{{ props.row.cash }}元</span>
            </el-form-item>

            <el-form-item label="冻结:">
              <span>{{ props.row.frozen }}元</span>
            </el-form-item>

            <el-form-item label="提现中:">
              <span>{{ props.row.cashing }}元</span>
            </el-form-item>

            <el-form-item label="拖欠款:">
              <span>{{ props.row.arrears }}元</span>
            </el-form-item>



          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id">
      </el-table-column>

      <el-table-column prop="group_name" label="集团名称">
      </el-table-column>
      <el-table-column prop="activity_status.alias" label="充值优惠状态">
      </el-table-column>


      <el-table-column prop="city.name" label="所属城市">
      </el-table-column>

      <el-table-column prop="balance" label="账户金额">
        <template slot-scope="scope">
          <span style="color: rgb(233, 161, 6);">
            {{scope.row.balance}}元
          </span>
        </template>
      </el-table-column>



      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="editGroup_show = !editGroup_show; editGroup_data = scope.row.group_wallet_code; " trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="groupRecord(scope.row)">集团账单</el-dropdown-item>
              <el-dropdown-item @click.native="delGroup(scope.row.group_wallet_code)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="activiteConf(scope.row)">充值配置</el-dropdown-item>
              <el-dropdown-item @click.native="editMember(scope.row)">集团成员</el-dropdown-item>
            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>



    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


    <!-- 添加组件 -->
    <addGroup :isShow="addGroup_show" @onSubmit="groupWalletLists"></addGroup>
    <!-- 集团流水组件 -->
    <waterGroupDrawer
      :isShow="water_isShow"
      :data="search_data"
    ></waterGroupDrawer>


    <!-- 编辑组件 -->
    <editGroup :isShow="editGroup_show" @onSubmit="groupWalletLists" :data="editGroup_data"></editGroup>
    <!-- 充值配置组件 -->
    <activiteConf :isShow="activiteConf_isShow" @onSubmit="groupWalletLists" :data="editGroup_data"></activiteConf>

    <!--  集团账单  -->
    <groupRecord
            :data="editGroup_data"
            :isShow="groupRecord_isShow"
            :name="group_name"
    ></groupRecord>


    <!--  集团成员  -->
    <editMember
            :data="editMember_data"
            :isShow="editMember_show"
            @onSubmit="groupWalletLists"
    ></editMember>

  </div>

</template>

<script>
  var _this;
  import addGroup from './addGroup.vue';
  import waterGroupDrawer from "./waterGroupDrawer.vue";
  import editGroup from './editGroup.vue';
  import activiteConf from './activiteConf.vue';
  import groupRecord from './groupRecord.vue';
  import editMember from './editMember.vue';
  export default {
    components: {
      addGroup,
      editGroup,
      activiteConf,
      groupRecord,
      waterGroupDrawer,
      editMember
    },

    data() {
      return {
        water_isShow: false,
        group_name:'',
        groupRecord_isShow:false,
        activiteConf_isShow:false,
        addGroup_show: false,
        editGroup_show: false,
        editGroup_data: '',
        activity_status: '',


        editMember_show: false,
        editMember_data:{},
        // 下拉搜索城市
        value_city_code: '',
        options_city_code: [],
        city_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },
        company_name: '',

        search_time: '',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          group_name: '',
          phone:'',
          activity_status: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.groupWalletLists();
    },

    methods: {
      editMember(e){
        this.editMember_show = !this.editMember_show;
        this.editMember_data = e;
      },

      groupRecord(e){
        _this.group_name = e.group_name;
        _this.editGroup_data = e.group_wallet_code;
        _this.groupRecord_isShow = !_this.groupRecord_isShow;
      },
      activiteConf(e){

        _this.editGroup_data = e.group_wallet_code;
        _this.activiteConf_isShow = !_this.activiteConf_isShow;
      },
      delGroup(code) {


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {


          _this.$post(
            "/group/deleteGroupWalletSubmit", {
              group_wallet_code: code
            }
          ).then(res => {

            _this.$message.success(res.msg);
            _this.groupWalletLists();

          }).catch((err) => {

          })





        }).catch(() => {

          _this.$message({
            message: '已取消删除',
            duration: 1500
          });

        });





      },



      timeChange(val) {

        _this.search_data.fixed_time = JSON.stringify(['between'].concat(val));

      },
      searchgroupWalletLists() {

        _this.search_data.page = 1;
        _this.groupWalletLists();

      },


      // 搜索司机日志列表
      groupWalletLists() {
        _this.$post(
            "/group/groupWalletLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.groupWalletLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },
      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>
